/* oxlint-disable no-inner-declarations */
import * as rq from '@tanstack/react-query';

import { appConfig } from '@/config';
import { useAuth } from '@/hooks/use-auth';
import { useMe } from '@/hooks/use-me';

import { communicationV1EmailsAttachmentsDownloadRetrieve } from '../../__generated__/oazapfts-client';
import type { CommunicationAttachment } from '../../entities/communication';

export namespace DownloadCommunicationAttachment {
  export type Input = Pick<CommunicationAttachment, 'id'>;
  export type Output = Blob;

  export function useMutation() {
    const auth = useAuth();
    const me = useMe();

    return rq.useMutation<Output, unknown, Input>({
      async mutationFn(input) {
        const accessToken = await auth.getAccessToken();
        const result = await communicationV1EmailsAttachmentsDownloadRetrieve(
          {
            fileId: input.id,
            xUserName: me.displayName,
            xUserEmail: me.email,
          },
          {
            baseUrl: `${appConfig.bffUrl}/plex`,
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          },
        );

        if (result.status !== 200) {
          throw new Error('Fail to create meeting minutes');
        }

        return result.data;
      },
    });
  }
}
